import { GlobalStyles } from "@mui/material";

const globalScrollbarStyles = (
  <GlobalStyles
    styles={{
      "::-webkit-scrollbar": {
        width: "0px",
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        borderRadius: "5px",
        "&:hover": {
          backgroundColor: "#555",
        },
      },
      "::-webkit-scrollbar-track": {
        backgroundColor: "#f0f0f0",
      },
    }}
  />
);

export default globalScrollbarStyles;
